import React from 'react';

// Create a context with an empty default value
export const CommonDataContext = React.createContext({});